/**
 * Workspace Help Content
 * 
 * Feature: 136-dashboard-alignment (T047)
 * Pages: /workspaces
 * Constitution: v1.12.0
 */

import type { PageHelpContent } from '../../components/ui/PageHelpPanel';

export const workspaceHelp: PageHelpContent = {
  pageTitle: 'Workspaces',
  purpose: 'Browse and manage Fabric workspaces across all capacities, with status indicators and capacity assignments.',
  sections: [
    {
      title: 'Overview',
      paragraphs: [
        'Workspaces are the primary organizational unit in Microsoft Fabric. Each workspace belongs to a capacity and contains lakehouses, warehouses, and other items. This page shows all discovered workspaces with their current status.',
      ],
    },
    {
      title: 'Status Indicators',
      concepts: [
        { term: 'Active', definition: 'Workspace is fully operational and accessible.' },
        { term: 'Inactive', definition: 'Workspace exists but is not currently in use or has been paused.' },
        { term: 'Deleted', definition: 'Workspace has been soft-deleted and may be recoverable within the retention period.' },
      ],
    },
    {
      title: 'Filtering & Search',
      paragraphs: [
        'Use the filters to narrow workspaces by capacity type, status, or client. The search bar matches workspace names and IDs. Results update in real-time as you type.',
      ],
    },
    {
      title: 'Capacity Assignment',
      paragraphs: [
        'Each workspace is assigned to exactly one capacity. The capacity type (Platform, Reference, ClientDedicated, MultiTenant) determines SLA requirements and resource isolation.',
      ],
    },
    {
      title: 'How To',
      steps: [
        { step: 1, instruction: 'Browse the workspace list to see all discovered workspaces and their current status (Active, Inactive, Deleted).' },
        { step: 2, instruction: 'Use the filter controls to narrow results by capacity type, status, or owning client.' },
        { step: 3, instruction: 'Type a workspace name or ID in the search bar to quickly locate a specific workspace.' },
        { step: 4, instruction: 'Click a workspace row to view its details, including capacity assignment and contained items (lakehouses, warehouses).' },
      ],
    },
    {
      title: 'Related Pages',
      links: [
        { label: 'Capacity Metrics', href: '/capacity-metrics' },
        { label: 'Lakehouses', href: '/lakehouses' },
        { label: 'Warehouses', href: '/warehouses' },
      ],
    },
  ],
};

export default workspaceHelp;
